export function splide() {
  new Splide(".splide", {
    autoplay: true, // 自動再生（デフォルトはfalse）
    interval: 4000, // 自動再生の間隔（autoplay有効時のみ）
    speed: 3000, // スライドの移動時間
    type: "fade", // フェード
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す（デフォルトはfalse）
    pagination: false,
    arrows: false,
  }).mount();
}